/**
 * Team grid.
 *
 * Ported from the section shell (`public/index.html:355-364`) and the cards the
 * page built at runtime (`:653-673`), including the staggered animation delay.
 */
import { TEAM_MEMBERS } from './teamMembers';

const TeamSection = () => (
  <section id="team" className="team-section">
    <div className="section-header">
      <h2 className="section-title">Our Team</h2>
      <p className="section-subtitle">Meet the researchers behind LungChat</p>
    </div>
    <div className="team-grid" id="teamGrid">
      {TEAM_MEMBERS.map((member, index) => (
        <div
          className="team-card"
          key={member.name}
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="team-image-wrapper">
            <img src={member.image} alt={member.name} />
          </div>
          <h4 className="team-name">{member.name}</h4>
          <p className="team-role">{member.role}</p>
          {member.link ? (
            <a
              href={member.link}
              className="team-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
            </a>
          ) : null}
        </div>
      ))}
    </div>
  </section>
);

export default TeamSection;
